import React from 'react';
import './FlashFeatures.css';

const FlashFeatures = () => {
  const features = [
    {
      number: '1',
      title: 'Wallet to wallet transfer maximum 60.'
    },
    {
      number: '2',
      title: 'Flash USDT expiry 140 to 160 days'
    },
    {
      number: '3',
      title: 'You can resell your Flash back to us'
    }
  ];

  return (
    <section className="flash-features">
      <div className="container">
        <div className="features-layout">
          <div className="features-left">
            <h2>Features of our<br /><span className="highlight">Flash USDT.</span></h2>
            <p className="features-subtitle">Do have any kind of questions? We're here to help.</p>
            
            <div className="document-illustration">
              <div className="document-card">
                <div className="document-header">
                  <div className="doc-lines">
                    <div className="doc-line short"></div>
                    <div className="doc-line"></div>
                  </div>
                  <div className="doc-image"></div>
                </div>
                <div className="document-body">
                  <div className="doc-line full"></div>
                  <div className="doc-line full"></div>
                  <div className="doc-line medium"></div>
                </div>
                <div className="document-footer">
                  <div className="doc-button"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="features-right">
            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-number">{feature.number}</div>
                  <div className="feature-title">{feature.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlashFeatures;
